export default __webpack_public_path__ + "static/media/Mom_Sick_3_2.cb86bc8a.png";